import { yyyyMmDdSchema } from "@redotech/redo-model/common/zod-util";
import * as z from "zod/v4";

const recoverMetricsSchema = z.object({
  initialSends: z.number(),
  replySends: z.number(),
  customerReplies: z.number(),
  uniqueCustomerReplies: z.number(),
  recoveredOrders: z.number(),
  recoveredRevenue: z.number(),
  unsubscribes: z.number(),
  skippedDueToUnsubscribe: z.number(),
  skippedDueToSkipConditions: z.number(),
  checkoutAbandonments: z.number(),
  controlSuppressed: z.number(),
});

const stepMetricsSchema = z.object({
  stepId: z.string(),
  stepName: z.string(),
  metrics: recoverMetricsSchema,
});

const automationMetricsSchema = z.object({
  automationId: z.string(),
  automationName: z.string(),
  triggerCategory: z.string(),
  enabled: z.boolean(),
  metrics: recoverMetricsSchema,
  steps: z.array(stepMetricsSchema),
});

export const GetRecoverAutomationMetricsInputSchema = z.object({
  startDate: yyyyMmDdSchema.describe(
    "Start date for the analytics period (YYYY-MM-DD)",
  ),
  endDate: yyyyMmDdSchema.describe(
    "End date for the analytics period (YYYY-MM-DD)",
  ),
  teamId: z.string().describe("Team ID to fetch automation metrics for"),
});

export const GetRecoverAutomationMetricsOutputSchema = z.object({
  automations: z.array(automationMetricsSchema),
});

export type GetRecoverAutomationMetricsInput = z.infer<
  typeof GetRecoverAutomationMetricsInputSchema
>;
export type GetRecoverAutomationMetricsOutput = z.infer<
  typeof GetRecoverAutomationMetricsOutputSchema
>;

export const getRecoverAutomationMetrics = {
  name: "getRecoverAutomationMetrics" as const,
  input: GetRecoverAutomationMetricsInputSchema,
  output: GetRecoverAutomationMetricsOutputSchema,
};
